import { Block, ProductColor } from '@aloft/toolkit-sui';

type Props = {
  color: ProductColor;
};

export const ValuationTablePropertyHeaderColorBand = ({ color }: Props) => (
  <Block width="100%" height="5px" backgroundColor={color} />
);
